import React, { useState, useEffect, useRef } from "react";
import axios from "../Axios/Axios";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import { Modal, Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import logo from "../assets/Mughallogo.jfif";

const AssignMaterial = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const [assignedMaterials, setAssignedMaterials] = useState([
    { materialId: "", assignedQuantity: "", letterDate: "" },
  ]);

  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedLicense, setSelectedLicense] = useState("");
  const [selectedMaterial, setSelectedMaterial] = useState("");
  const [availableQty, setAvailableQty] = useState(0);
  const [assignQty, setAssignQty] = useState("");
  const [remainingQty, setRemainingQty] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const [showLicenseModal, setShowLicenseModal] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [customerImageFile, setCustomerImageFile] = useState(null);
  const [deliverySlipNo, setDeliverySlipNo] = useState("");
  const [lotNo, setLotNo] = useState("");
  const [batchNo, setBatchNo] = useState("");
  const [shellNo, setShellNo] = useState("");
  const [detonatorNo, setDetonatorNo] = useState("");
  const [waboxBatchNo, setWaboxBatchNo] = useState("");
  const [sfuseBatchNo, setSfuseBatchNo] = useState("");
  const [reelNo, setReelNo] = useState("");
  const [showCamera, setShowCamera] = useState(false);
  const [capturedImage, setCapturedImage] = useState(null);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  const [newLicenseNumber, setNewLicenseNumber] = useState("");
  const [newLicenseExpiry, setNewLicenseExpiry] = useState("");

  const [materials, setMaterials] = useState([]);
  const handleClose = () => setShowModal(false);

  useEffect(() => {
    const mughalsLoggedIn = localStorage.getItem("mughalsLoggedIn");

    const fetchCustomers = async () => {
      try {
        setLoading(true);
        const res = await axios.get("/api/customers", {
          headers: {
            Authorization: `Bearer ${mughalsLoggedIn}`,
          },
        });
        console.log(res);
        setCustomers(res.data);
      } catch (err) {
        setError("Failed to fetch customer data.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    const fetchMaterials = async () => {
      try {
        const res = await axios.get("/api/materials/all", {
          headers: {
            Authorization: `Bearer ${mughalsLoggedIn}`,
          },
        });
        setMaterials(res.data); // assumes array of materials
      } catch (err) {
        console.error("Error fetching materials:", err);
      }
    };

    fetchCustomers();
    fetchMaterials();
  }, []);

  useEffect(() => {
    if (showCamera) {
      const startCamera = async () => {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({
            video: true,
          });
          if (videoRef.current) {
            videoRef.current.srcObject = stream;
            videoRef.current.play();
          }
        } catch (err) {
          console.error("Camera error:", err);
          Swal.fire(
            "Camera Error",
            "Could not access camera. Please allow permission.",
            "error"
          );
          setShowCamera(false);
        }
      };
      startCamera();
    } else {
      if (videoRef.current && videoRef.current.srcObject) {
        videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
        videoRef.current.srcObject = null;
      }
    }
  }, [showCamera]);

  useEffect(() => {
    const material = materials.find((mat) => mat._id === selectedMaterial);
    if (material) {
      setAvailableQty(material.quantity);
      setRemainingQty(material.quantity - (parseInt(assignQty) || 0));
    } else {
      setAvailableQty(0);
      setRemainingQty(0);
    }
  }, [selectedMaterial, assignQty, materials]);

  const handleAddNewLicense = async () => {
    const mughalsLoggedIn = localStorage.getItem("mughalsLoggedIn");

    if (!newLicenseNumber || !newLicenseExpiry) {
      Swal.fire("Error", "Please fill all fields", "error");
      return;
    }

    try {
      const response = await axios.put(
        `/api/customers/updatelicense/${selectedCustomer._id}`,
        {
          name: selectedCustomer?.name,
          NIC: selectedCustomer?.NIC,
          newLicense: {
            licenseNumber: newLicenseNumber,
            LicenseExpiryDate: newLicenseExpiry,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${mughalsLoggedIn}`,
            "Content-Type": "application/json",
          },
        }
      );

      // ✅ Update local state with updated customer licenses
      const updatedCustomer = {
        ...selectedCustomer,
        licenses: response.data.licenses,
      };

      setSelectedCustomer(updatedCustomer);
      setCustomers((prev) =>
        prev.map((cust) =>
          cust._id === updatedCustomer._id ? updatedCustomer : cust
        )
      );
      setShowLicenseModal(false);
      setNewLicenseNumber("");
      setNewLicenseExpiry("");
      Swal.fire("Success", "License added successfully", "success");
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to add license", "error");
    }
  };

  const captureImage = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    ctx.drawImage(video, 0, 0);

    const dataUrl = canvas.toDataURL("image/png");
    setCapturedImage(dataUrl);

    canvas.toBlob((blob) => {
      const capturedFile = new File([blob], "captured.png", {
        type: "image/png",
      });
      setCustomerImageFile(capturedFile);
    });

    setShowCamera(false);
  };

  const [selectedFile, setSelectedFile] = useState(null);
  const [letterDate, setLetterDate] = useState("");

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleSubmit = async () => {
    if (!selectedFile) {
      alert("Please select an image");
      return;
    }
    const mughalsLoggedIn = localStorage.getItem("mughalsLoggedIn");

    const formData = new FormData();
    formData.append("authorityLetter", selectedFile);
    formData.append("letterDate", letterDate);

    try {
      const response = await axios.put(
        `/api/customers/update-authorityletters/${selectedCustomer._id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${mughalsLoggedIn}`,
          },
        }
      );

      alert("Authority Letter uploaded successfully");
      handleClose();
    } catch (error) {
      console.error(error);
      alert("Failed to upload authority letter");
    }
  };

  const handleConfirmAssign = async () => {
    const mughalsLoggedIn = localStorage.getItem("mughalsLoggedIn");
    const formData = new FormData();

    formData.append("customerId", selectedCustomer._id);
    formData.append("customerNIC", selectedCustomer.NIC);
    formData.append("license", selectedLicense);

    formData.append("deliverySlipNo", deliverySlipNo);
    formData.append("lotNo", lotNo);
    formData.append("batchNo", batchNo);
    formData.append("shellNo", shellNo);
    formData.append("detonatorNo", detonatorNo);
    formData.append("waboxBatchNo", waboxBatchNo);
    formData.append("sfuseBatchNo", sfuseBatchNo);
    formData.append("reelNo", reelNo);

    formData.append("assignedMaterials", JSON.stringify(assignedMaterials));

    if (customerImageFile) {
      formData.append("customerImage", customerImageFile);
    }
    if (selectedFile) {
      formData.append("authorityLetterImage", selectedFile);
    }

    try {
      const res = await axios.post("/api/assignmaterial/assign", formData, {
        headers: {
          Authorization: `Bearer ${mughalsLoggedIn}`,
          "Content-Type": "multipart/form-data",
        },
      });

      Swal.fire("Success", "Material assigned successfully", "success");
      navigate("/history");
    } catch (error) {
      console.error("Assignment failed:", error);
      Swal.fire("Error", "Failed to assign materials.", "error");
    }
  };

  const getBase64FromImage = (imgPath) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      fetch(imgPath)
        .then((res) => res.blob())
        .then((blob) => {
          reader.readAsDataURL(blob);
          reader.onloadend = () => resolve(reader.result);
        });
    });
  };

  return (
    <div className="mt-4 p-4">
      <h4 className="mb-4">Give Materials</h4>

      <div className="mb-3">
        <label className="form-label text-dark">Select Customer</label>
        <select
          className="form-select"
          value={selectedCustomer?._id || ""}
          onChange={(e) => {
            if (e.target.value === "add_customer") {
              navigate("/AddCustomer");
            } else {
              const found = customers.find((c) => c._id === e.target.value);
              setSelectedCustomer(found || null);
              setSelectedLicense("");
            }
          }}
        >
          <option value="">-- Select --</option>
          {customers?.map((cust) => (
            <option key={cust._id} value={cust._id}>
              {cust.name}
            </option>
          ))}
          <option value="add_customer" className="text-lemon">
            ➕ Add New Customer
          </option>
        </select>
      </div>

      {selectedCustomer && (
        <>
          <div className="mb-3">
            <label className="form-label text-dark">NIC</label>
            <input
              type="text"
              className="form-control"
              value={selectedCustomer.NIC}
              readOnly
            />
          </div>

          <div className="mb-3">
            <label className="form-label text-dark">Select License</label>
            <select
              className="form-select"
              value={selectedLicense}
              onChange={(e) => {
                if (e.target.value === "add_new_license") {
                  setShowLicenseModal(true);
                } else if (e.target.value === "add_new_auth_letter") {
                  setShowAuthModal(true);
                } else {
                  setSelectedLicense(e.target.value);
                }
              }}
            >
              <option value="">-- Select License --</option>

              {selectedCustomer.licenses?.map((license) => {
                const today = new Date().toISOString().split("T")[0];
                const expiryDate = new Date(license.LicenseExpiryDate)
                  .toISOString()
                  .split("T")[0];

                const isExpiredToday = expiryDate === today;

                return (
                  <option
                    key={license._id}
                    value={license._id}
                    disabled={isExpiredToday}
                  >
                    {license.licenseNumber}{" "}
                    {isExpiredToday ? "(Expired Today)" : ""}
                  </option>
                );
              })}

              <option value="add_new_license" className="text-lemon">
                ➕ Add New License
              </option>
              <option value="add_new_auth_letter" className="text-lemon">
                ➕ Add Auth Letter
              </option>
            </select>
          </div>
        </>
      )}

      {showLicenseModal && selectedCustomer && (
        <Modal
          show={showLicenseModal}
          onHide={() => setShowLicenseModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Add New License</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <label className="form-label text-dark">Customer</label>
              <input
                type="text"
                className="form-control"
                value={selectedCustomer?.name}
                readOnly
              />
            </div>
            <div className="mb-3">
              <label className="form-label text-dark">License Number</label>
              <input
                type="text"
                className="form-control"
                value={newLicenseNumber}
                onChange={(e) => setNewLicenseNumber(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label text-dark">Expiry Date</label>
              <input
                type="date"
                className="form-control"
                value={newLicenseExpiry}
                onChange={(e) => setNewLicenseExpiry(e.target.value)}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="bg-lemon text-white border-0"
              onClick={() => setShowLicenseModal(false)}
            >
              Cancel
            </Button>
            <Button
              className="bg-lemon text-white border-0"
              onClick={handleAddNewLicense}
            >
              Add License
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {selectedCustomer && (
        <>
          <h5 className="mt-4">Assign Materials</h5>
          {assignedMaterials.map((item, index) => (
            <div key={index} className="border p-3 mb-3 rounded">
              <div className="mb-2">
                <label className="form-label text-dark">Material</label>
                <select
                  className="form-select"
                  value={item.materialId}
                  onChange={(e) => {
                    const updated = [...assignedMaterials];
                    updated[index].materialId = e.target.value;
                    setAssignedMaterials(updated);
                  }}
                >
                  <option value="">-- Select Material --</option>
                  {materials.map((mat) => (
                    <option key={mat._id} value={mat._id}>
                      {mat.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-2">
                <label className="form-label text-dark">Quantity</label>
                <input
                  type="number"
                  className="form-control"
                  value={item.assignedQuantity}
                  onChange={(e) => {
                    const updated = [...assignedMaterials];
                    updated[index].assignedQuantity = e.target.value;
                    setAssignedMaterials(updated);
                  }}
                />
              </div>
            </div>
          ))}
          <button
            className="btn  bg-lemon text-white mb-3"
            onClick={() =>
              setAssignedMaterials([
                ...assignedMaterials,
                { materialId: "", assignedQuantity: "", letterDate: "" },
              ])
            }
          >
            + Add Another Material
          </button>
        </>
      )}

      <>
        <div className="mb-3">
          <label className="form-label text-dark">Upload Customer Image</label>
          {!capturedImage ? (
            <>
              {/* <input type="file" className="form-control mb-2" onChange={e => setCustomerImageFile(e.target.files[0])} /> */}
              <button
                className="btn btn-md ms-2 text-white bg-lemon"
                onClick={() => setShowCamera(true)}
              >
                📸 Capture via Camera
              </button>
            </>
          ) : (
            <div className="mb-2">
              <img
                src={capturedImage}
                alt="Captured"
                className="img-fluid rounded shadow"
                style={{ maxWidth: "300px" }}
              />
              <button
                className="btn btn-sm ms-2 bg-lemon text-white mt-2"
                onClick={() => {
                  setCapturedImage(null);
                  setCustomerImageFile(null);
                }}
              >
                ❌ Remove
              </button>
            </div>
          )}
        </div>
        <div className="mb-3">
          <label className="form-label text-dark">Delivery Slip No</label>
          <input
            type="text"
            className="form-control"
            value={deliverySlipNo}
            onChange={(e) => setDeliverySlipNo(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label text-dark">Lot No</label>
          <input
            type="text"
            className="form-control"
            value={lotNo}
            onChange={(e) => setLotNo(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label text-dark">Batch No</label>
          <input
            type="text"
            className="form-control"
            value={batchNo}
            onChange={(e) => setBatchNo(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label text-dark">Shell No</label>
          <input
            type="text"
            className="form-control"
            value={shellNo}
            onChange={(e) => setShellNo(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label text-dark">Detonator No</label>

          {[
            { label: "1 - 40", range: [1, 40] },
            { label: "41 - 80", range: [41, 80] },
            { label: "81 - 100 (A)", range: [81, 100] },
            { label: "81 - 100 (B)", range: [81, 100] },
          ].map((item, index) => {
            const value = Array.from(
              { length: item.range[1] - item.range[0] + 1 },
              (_, i) => i + item.range[0]
            ).join(",");
            return (
              <div className="form-check" key={index}>
                <input
                  className="form-check-input"
                  type="radio"
                  name="detonator"
                  id={`detRange${index}`}
                  value={value}
                  checked={detonatorNo === value}
                  onChange={(e) => setDetonatorNo(e.target.value)}
                />
                <label
                  className="form-check-label"
                  htmlFor={`detRange${index}`}
                >
                  {item.label}
                </label>
              </div>
            );
          })}
        </div>

        <div className="mb-3">
          <label className="form-label text-dark">Dets Batch No</label>
          <input
            type="text"
            className="form-control"
            value={waboxBatchNo}
            onChange={(e) => setWaboxBatchNo(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label text-dark">SFuse Batch No</label>
          <input
            type="text"
            className="form-control"
            value={sfuseBatchNo}
            onChange={(e) => setSfuseBatchNo(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label text-dark">Reel No</label>
          <input
            type="text"
            className="form-control"
            value={reelNo}
            onChange={(e) => setReelNo(e.target.value)}
          />
        </div>

        <button
          className="btn btn-lg border-0 bg-lemon text-white px-4"
          onClick={() => setShowModal(true)}
          disabled={!selectedCustomer}
        >
          Give Material
        </button>

        {showModal && (
          <Modal show={showModal} onHide={handleClose} centered size="lg">
            <Modal.Header
              closeButton
              className="text-white border-0"
              style={{ backgroundColor: "#6fb104" }}
            >
              <Modal.Title>
                <i className="fas fa-file-alt me-2"></i>Confirm Assignment
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className="px-4 py-3">
              <div className="mb-3">
                <h5 className="text-lemon">Customer Details</h5>
                <p>
                  <strong>Name:</strong> {selectedCustomer.name}
                </p>
                <p>
                  <strong>NIC:</strong> {selectedCustomer.NIC}
                </p>
                <p>
                  <strong>License No:</strong>{" "}
                  {
                    selectedCustomer.licenses?.find(
                      (l) => l._id === selectedLicense
                    )?.licenseNumber
                  }
                </p>
              </div>

              <div className="mb-3">
                <h5 className="text-lemon">Material Information</h5>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>S. No</th>
                      <th>Material</th>
                      <th>Quantity</th>
                      {/* <th>Letter Date</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {assignedMaterials.map((item, idx) => {
                      const mat = materials.find(
                        (m) => m._id === item.materialId
                      );
                      return (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>{mat ? mat.name : "N/A"}</td>
                          <td>{item.assignedQuantity}</td>
                          {/* <td>{item.letterDate || '-'}</td> */}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <div className="mb-3 w-100  overflow-x-scroll">
                <h5 className="text-lemon">Additional Assignment Details</h5>
                <table className="table w-100 table-sm table-bordered table-responsive">
                  <tbody>
                    <tr>
                      <td>
                        <strong>Delivery Slip No</strong>
                      </td>
                      <td>{deliverySlipNo || "-"}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Lot No</strong>
                      </td>
                      <td>{lotNo || "-"}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Batch No</strong>
                      </td>
                      <td>{batchNo || "-"}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Shell No</strong>
                      </td>
                      <td>{shellNo || "-"}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Detonator No</strong>
                      </td>
                      <td>{detonatorNo || "-"}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Dets Batch No</strong>
                      </td>
                      <td>{waboxBatchNo || "-"}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>SFuse Batch No</strong>
                      </td>
                      <td>{sfuseBatchNo || "-"}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Reel No</strong>
                      </td>
                      <td>{reelNo || "-"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div
                className="alert alert-warning mt-4 bg-lemon text-white"
                role="alert"
              >
                Are you sure you want to <strong>assign</strong> this material
                to this customer?
              </div>
            </Modal.Body>

            <Modal.Footer className="d-flex justify-content-between px-4">
              <Button
                className="text-white bg-lemon border-0"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <button
                className="btn px-5 text-white border-0"
                style={{ backgroundColor: "#6fb104" }}
                onClick={async () => {
                  setConfirming(true);
                  try {
                    await handleConfirmAssign(); // API call

                    const { jsPDF } = await import("jspdf");
                    const autoTable = (await import("jspdf-autotable")).default;

                    const doc = new jsPDF("p", "mm", [210, 240]);
                    const pageWidth = doc.internal.pageSize.getWidth();
                    let y = 10;

                    // ===== Header at Top =====
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(18);
                    doc.text("Mughal Blasting Services", pageWidth / 2, y, {
                      align: "center",
                    });

                    y += 8;
                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(12);
                    doc.text("Receiving Explosives EL04", pageWidth / 2, y, {
                      align: "center",
                    });

                    // Date, Time, Slip#
                    y += 12;
                    const today = new Date();
                    const dateStr = today.toLocaleDateString();
                    const timeStr = today.toLocaleTimeString();

                    doc.setFontSize(10);
                    doc.text(`Date: ${dateStr}`, 14, y);
                    doc.text(`Time: ${timeStr}`, 14, y + 6);

                    // Slip# → Left side (where logo used to be)
                    doc.text(`Slip#: ${deliverySlipNo || "-"}`, 14, y + 12);

                    // Load and draw logo on RIGHT side now
                    const image = new Image();
                    image.src = "./logo.png";

                    image.onload = function () {
                      const canvas = document.createElement("canvas");
                      canvas.width = image.width;
                      canvas.height = image.height;
                      const ctx = canvas.getContext("2d");
                      ctx.drawImage(image, 0, 0);
                      const imageData = canvas.toDataURL("image/png");

                      // Logo → Right side
                      const logoWidth = 40;
                      const logoHeight = 20;
                      const rightX = pageWidth - logoWidth - 14;

                      doc.addImage(
                        imageData,
                        "PNG",
                        rightX,
                        y,
                        logoWidth,
                        logoHeight
                      );

                      // Move y below logo
                      y += 38;

                      // Continue with the rest of PDF content...

                      // ===== Customer Info Box =====
                      doc.setFont("helvetica", "bold");
                      doc.rect(14, y, 182, 30);
                      doc.text("Customer Details", 16, y + 6);

                      y += 12;
                      doc.setFont("helvetica", "normal");
                      doc.setFontSize(10);

                      doc.text(`Name: ${selectedCustomer.name}`, 16, y);
                      doc.text(`CNIC: ${selectedCustomer.NIC}`, 110, y);
                      y += 6;
                      doc.text(
                        `Delivery Slip#: ${deliverySlipNo || "-"}`,
                        110,
                        y
                      );

                      // y += 2;
                      doc.text(
                        `License#: ${
                          selectedCustomer.licenses?.find(
                            (l) => l._id === selectedLicense
                          )?.licenseNumber || "-"
                        }`,
                        16,
                        y
                      );

                      // ===== Lot/Batch/Shell/Reel OUTSIDE Customer Box =====
                      y += 17;
                      doc.setFont("helvetica", "bold");
                      doc.text("Explosive Identifiers:", 16, y);

                      y += 6;
                      doc.setFont("helvetica", "normal");
                      doc.text(`Lot#: ${lotNo || "-"}`, 16, y);
                      doc.text(`Batch#: ${batchNo || "-"}`, 110, y);

                      y += 6;
                      doc.text(`Shell#: ${shellNo || "-"}`, 16, y);
                      doc.text(`Reel#: ${reelNo || "-"}`, 110, y);

                      // ===== Detonator Section =====
                      y += 12;

                      const renderMultiCol = (
                        label,
                        value,
                        x,
                        startY,
                        cols = 6,
                        lineGap = 6
                      ) => {
                        let yPos = startY;
                        const nums = (value || "-")
                          .replace(/\s+/g, "")
                          .split(",")
                          .filter((n) => n);

                        doc.setFont("helvetica", "bold");
                        doc.text(`${label}:`, x, yPos);
                        doc.setFont("helvetica", "normal");

                        for (let i = 0; i < nums.length; i += cols) {
                          yPos += lineGap;
                          const line = nums.slice(i, i + cols).join(", ");
                          doc.text(line, x, yPos);
                        }
                        return yPos + 4;
                      };

                      y = renderMultiCol("Detonator No", detonatorNo, 16, y);

                      y += 6;
                      doc.text(`Dets Batch#: ${waboxBatchNo || "-"}`, 16, y);
                      doc.text(`SFuse Batch#: ${sfuseBatchNo || "-"}`, 110, y);

                      y += 12;

                      // ===== Material Table (Letter Date Removed) =====
                      const tableData = assignedMaterials.map((mat, idx) => {
                        const material = materials.find(
                          (m) => m._id === mat.materialId
                        );
                        return [
                          idx + 1,
                          material?.name || "N/A",
                          mat.assignedQuantity,
                        ];
                      });

                      autoTable(doc, {
                        head: [["S.No", "Material Name", "Quantity"]],
                        body: tableData,
                        startY: y,
                        styles: {
                          fontSize: 10,
                          cellPadding: 2,
                          textColor: [0, 0, 0],
                        },
                        headStyles: {
                          fillColor: [220, 220, 220],
                          textColor: [0, 0, 0],
                        },
                        theme: "grid",
                      });

                      const finalY = doc.lastAutoTable.finalY + 20;
                      doc.setFont("helvetica", "italic");
                      doc.text("Received By: ___________________", 14, finalY);
                      doc.text(
                        "Thumb/Signature: ___________________",
                        pageWidth - 100,
                        finalY
                      );

                      // Save PDF
                      doc.save(
                        `DeliverySlip_${
                          selectedCustomer.name
                        }_${dateStr.replace(/\//g, "-")}.pdf`
                      );
                    };
                  } catch (error) {
                    console.error(error);
                  } finally {
                    setConfirming(false);
                  }
                }}
                disabled={confirming}
              >
                {confirming ? "Please wait..." : "Confirm & Print"}
              </button>
            </Modal.Footer>
          </Modal>
        )}
      </>

      {showAuthModal && selectedCustomer && (
        <Modal
          show={showAuthModal}
          onHide={() => setShowAuthModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Add Authority Letter</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="formFile">
              <Form.Label>Select Authority Letter Image</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={handleFileChange}
              />
            </Form.Group>

            <Form.Group controlId="letterDate" className="mt-3">
              <Form.Label>Letter Date</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter letter date (e.g. 2025-06-17)"
                value={letterDate}
                onChange={(e) => setLetterDate(e.target.value)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="bg-lemon text-white border-0"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              className="bg-lemon text-white border-0"
              onClick={handleSubmit}
            >
              Add Authority Letter
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {showCamera && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark d-flex justify-content-center align-items-center"
          style={{ zIndex: 9999 }}
        >
          <video
            ref={videoRef}
            className="w-100 h-100"
            style={{
              objectFit: "cover",
              maxHeight: "100vh",
              maxWidth: "100vw",
            }}
            autoPlay
            playsInline
          />
          <canvas ref={canvasRef} style={{ display: "none" }} />
          <div className="position-absolute bottom-0 d-flex justify-content-center gap-3 mb-4">
            <button className="btn bg-lemon text-white" onClick={captureImage}>
              📷 Capture
            </button>
            <button
              className="btn bg-lemon text-white"
              onClick={() => setShowCamera(false)}
            >
              ❌ Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AssignMaterial;
